import {httpsCallable} from 'firebase/functions';
import {signOut} from 'firebase/auth';
import {functions} from './firebase';
// These contextual activity records are explicitly labelled as app-reported.
// Confirmed changes are independently captured by database triggers.
export const logAuditAction=async(user,action,details,target=null)=>{
 if(!user)return;
 try {await httpsCallable(functions,'recordPlatformActivity')({action:action.toUpperCase(),details,targetId:target?.id||target?.attemptId||'',targetName:target?.name||'',requestId:(typeof window!=='undefined'?window.crypto?.randomUUID?.():null)||`${Date.now()}-${Math.random().toString(36).slice(2)}`});}
 catch(error){console.warn('Activity receipt unavailable; database change auditing is independent.');}
};
export async function signOutWithAudit(auth){
 if(auth.currentUser)await Promise.race([logAuditAction(auth.currentUser,'SIGN_OUT','Signed out of the platform'),new Promise(resolve=>setTimeout(resolve,1500))]);
 return signOut(auth);
}
